<div class="container-fluid inbuilt-table-block p-1 mt-1" *ngIf="showTable && !tableLoader">
    <div class="row">
        <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
            <div class="d-flex align-items-center">
                <p class="m-0 mt-2 report-fetch-details">{{config.reportNameFromQueryParams | titlecase}} :
                    {{maxResultCount}} rows as of {{currentDate | date: 'MMMdd,yyyy':'GMT'}} {{currentTime}}</p>

            </div>
            <!-- <mat-form-field class="data-filter" appearance="outline">
                    <input
                      [(ngModel)]="searchText"
                      matInput
                      type="text"
                      class=""
                      placeholder="Search by any field"
                      (input)="onSearchTextChanged($event)"
                    />
                    <img src="../../../../assets/images/searchicon.png" class="search-img" />
                  </mat-form-field> -->
            <!-- <input type="text" class="form-control" placeholder="Search by any field" [(ngModel)]="searchText" (input)="onSearchTextChanged()"> -->
        </div>
        <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 text-right">
            <div class="m-2 d-flex align-items-center justify-content-end flex-wrap gap-2">
                <span class="m-0"><span class="note-text ms-1">Note*</span><span class="ps-1">Click Refresh to get
                        latest table data</span><button
                        class="ms-2 me-0 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                        (click)="refreshTableData()">Refresh</button></span>
                
                <span *ngIf="isJSONeditorEnabled" class="json-editor-icon"><mat-icon title="Edit Table JSON"  (click)="openJSONeditor()">
                        create
                    </mat-icon>
                    <mat-icon class="ms-1" title="Delete Report" (click)="deleteReport()">
                        delete
                    </mat-icon>
                </span>
                <span (click)="!isDownloadDisabled && downloadAndExportToExcel()" title="Click to Download"
                    [class.cursor-not-allowed]="isDownloadDisabled"
                    [class.opacity-50]="isDownloadDisabled"
                    [ngClass]="{'pointer-events-none': isDownloadDisabled}"
                    class="uitk-icon uitk-icon-download md-icon excel_Download cursor-pointer excelandinfo-Icon-font"></span>
                <div class="export-loader ms-2" *ngIf="isExporting" style="display: inline-block;">
                    <mat-spinner class="spinner" diameter="24"></mat-spinner>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12" *ngIf="elementData?.isAttributeVisibile && attributeDropdownData.length > 0">
            <div class="attribute-dropdown-block">
                <label class="attribute-dropdown-label">Attributes</label>
                <app-lazy-load-select-dropdown [dropdownData]="attributeDropdownData"
                    [initialSelectedItems]="attributeInitialSelection" [searchFlag]="true" [isMultiselect]="true"
                    [isSelectAll]="false" [isDataSorted]="false" [resetTrigger]="attributeResetCounter"
                    (selectionChange)="onAttributeSelectionChange($event)">
                </app-lazy-load-select-dropdown>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12 ag-table-container position-relative">
            <ag-grid-angular style="width: 100%; height: 60vh;" [rowData]="filteredTableData" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" [animateRows]="true"
                (bodyScroll)="onBodyScroll($event)" (sortChanged)="onSortChanged($event)" class="ag-theme-alpine">
            </ag-grid-angular>
            <!-- [pagination]="true"
                [paginationPageSize]="10"
                [paginationPageSizeSelector]="[10, 20, 50, 100]" -->
            <div class="table-loading-overlay" *ngIf="loading">
                <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
            </div>
            
        </div>
    </div>
    
</div>
<div class="d-flex align-items-center justify-content-center" *ngIf="tableLoader">
        <app-loader></app-loader>
    </div>

<app-export-file-popup
    #exportFileAsPopup
    (exportConfirmed)="confirmExportWithOptionalSuffix($event)"
    (popupClosed)="closeExportFileAsPopup()">
</app-export-file-popup>
    <app-modal [maximizable]="true" [inViewport]="true" #modalEditJSON class="modal-demo  edit-json-popup"
        (closeModal)="hidepopup('edit')">
        <ng-container class="app-modal-header">Visual Editor</ng-container>
        <ng-container class="app-modal-body">
            <ng-container *ngIf="isJSONeditorPopupOpen">
                <app-inbuilt-editor [initialJson]="elementData?.element_json || {}" [queryCode]="elementData?.Constructed_Query || ''" (jsonTextChange)="onJsonEditorTextChange($event)"></app-inbuilt-editor>
            </ng-container>
        </ng-container>
    </app-modal>

